import React from "react";
import {
  faFileImage,
  faFilePdf,
  faFileWord,
  faTimesCircle,
} from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import FetchButton from "../../../../common/button/FetchButton";

export const icon = (type) => {
  if (type === "pdf") {
    return faFilePdf;
  } else {
    if (type === "docx") {
      return faFileWord;
    } else {
      return faFileImage;
    }
  }
};

export const iconColor = (type) => {
  return type === "pdf" ? "danger" : type === "word" ? "info" : "dark";
};

function SubmittedDocumentation({ letters, attachments, finances }) {
  const { t } = useTranslation();

  return (
    <>
      <div className="subtitle mt-4">
        {t("requests.submittedDocumentation.letters")} ({letters && letters.length})
      </div>
      <table className="is-fullwidth table is-size-6 is-hoverable">
        <tbody>
          {letters &&
            letters.map((letter, index) => {
              if (letter.href !== null) {
                return (
                  <tr key={"letter" + index}>
                    <td>{letter.label}</td>
                    <td className="has-text-right">
                      <FetchButton
                        fileToDownload={letter}
                        href={letter.href}
                        className="button is-white has-background-transparent has-background-transparent-on-hover"
                        text={
                          <FontAwesomeIcon
                            className={`is-clickable has-text-${iconColor(letter.content)}`}
                            icon={icon(letter.content)}
                            size={"2x"}
                          />
                        }
                      />
                    </td>
                  </tr>
                );
              }
            })}
        </tbody>
      </table>
      <div className="subtitle">
        {t("requests.submittedDocumentation.attachments")} ({attachments && attachments.length})
      </div>
      <table className="is-fullwidth table is-size-6 is-hoverable">
        <tbody>
          {attachments &&
            attachments.map((attachment, index) => {
              if (attachment.href !== null) {
                return (
                  <tr key={"attachment" + index}>
                    <td>{attachment.label}</td>
                    <td className="has-text-right">
                      <FetchButton
                        fileToDownload={attachment}
                        href={attachment.href}
                        className="button has-background-transparent is-white has-background-transparent-on-hover"
                        text={
                          <FontAwesomeIcon
                            className={`is-clickable has-text-${iconColor(attachment.content)}`}
                            icon={icon(attachment.content)}
                            size={"2x"}
                          />
                        }
                      />
                    </td>
                  </tr>
                );
              }
            })}
        </tbody>
      </table>
      {/* Uklonjene financije */}
      {/* <div className="subtitle">
        {t("requests.submittedDocumentation.finances")} ({finances && finances.length})
      </div> */}
      {/* <table className="is-fullwidth table is-size-6 is-hoverable">
        <tbody>
          {finances &&
            finances.map((finance, index) => (
              <tr key={"finance" + index}>
                <td>{finance.label}</td>
                <td className="has-text-right">
                  <FontAwesomeIcon
                    className={`is-clickable has-text-${iconColor(finance.content)}`}
                    icon={icon(finance.content)}
                    size={"2x"}
                  />
                </td>
              </tr>
            ))}
        </tbody>
      </table> */}
    </>
  );
}

export default SubmittedDocumentation;
